import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingPagesLayout from '../../components/Layout/OnboardingLayout';
import OnboardingWizard from '../../components/Onboarding/OnboardingWizard';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/rootReducer';
import { CoachStatus } from '../../types/coach';
import { CLIENTS_ROUTE } from '../../utils/routes';
import CoachOnboardingLoading from '../../components/Onboarding/LoadingScreen/LoadingScreen';

export default function Onboarding() {
  const navigate = useNavigate();
  const coachStatus = useAppSelector((state: RootState) => state.coach.coach.status);
  const addTherapistLoading = useAppSelector(
    (state: RootState) => state.onboarding.addTherapistLoading
  );

  useEffect(() => {
    if (coachStatus === CoachStatus.COMPLETED) {
      navigate(CLIENTS_ROUTE, { replace: true });
    }
  }, [coachStatus]);

  return addTherapistLoading ? (
    <CoachOnboardingLoading />
  ) : (
    <OnboardingPagesLayout xs={11} md={10} lg={8}>
      <OnboardingWizard />
    </OnboardingPagesLayout>
  );
}
